const carouselItems = [
  {
    title: '暑期国产大片专题',
    desc: '精选2026年暑期最值得观看的91国产免费视频大片合集，从动作到悬疑应有尽有。',
    label: '热门专题',
    img: 'https://readdy.ai/api/search-image?query=A%20summer%20blockbuster%20cinematic%20abstract%20design%20with%20vibrant%20warm%20red%20and%20golden%20amber%20gradients%2C%20epic%20film%20festival%20theme%2C%20dramatic%20light%20beams%2C%20dark%20rich%20background%2C%20summer%20movie%20season%20vibe%2C%20no%20people%20no%20text%2C%20grand%20cinematic%20aesthetic&width=800&height=500&seq=car-1-summer-2026&orientation=landscape',
  },
  {
    title: '91传媒视频在线年度精选',
    desc: '传媒团队年度力作集合，高品质制作水准代表了91传媒视频在线的最高水平。',
    label: '年度精选',
    img: 'https://readdy.ai/api/search-image?query=A%20prestigious%20award-show%20cinematic%20abstract%20design%20with%20deep%20crimson%20and%20gold%20gradients%2C%20trophy%20and%20spotlight%20motifs%2C%20dark%20elegant%20background%2C%20best%20of%20year%20theme%2C%20no%20people%20no%20text%2C%20luxurious%20film%20accolade%20aesthetic&width=800&height=500&seq=car-2-annual-2026&orientation=landscape',
  },
  {
    title: '国产悬疑推理剧场',
    desc: '烧脑悬疑片爱好者必看专区，汇集91国产免费视频中最具推理魅力的作品。',
    label: '类型剧场',
    img: 'https://readdy.ai/api/search-image?query=A%20mysterious%20detective%20cinematic%20abstract%20design%20with%20dark%20red%20and%20shadow%20gradients%2C%20magnifying%20glass%20and%20clue%20motifs%2C%20dark%20atmospheric%20background%2C%20crime%20thriller%20theme%2C%20no%20people%20no%20text%2C%20film%20noir%20mystery%20aesthetic&width=800&height=500&seq=car-3-mystery-2026&orientation=landscape',
  },
  {
    title: '经典国产老片修复展',
    desc: '91年国产影片视频数字修复成果展示，经典作品以全新画质焕发新生。',
    label: '特别企划',
    img: 'https://readdy.ai/api/search-image?query=A%20vintage%20classic%20cinema%20abstract%20design%20with%20sepia%20gold%20and%20warm%20amber%20gradients%2C%20old%20film%20projector%20motif%2C%20nostalgic%20timeless%20feel%2C%20dark%20rich%20background%2C%20classic%20film%20restoration%20theme%2C%20no%20people%20no%20text%2C%20elegant%20vintage%20aesthetic&width=800&height=500&seq=car-4-classic-2026&orientation=landscape',
  },
  {
    title: '每天50+新片速递',
    desc: '每日更新的国产免费视频专区，确保您每天都有新鲜内容可以观看，告别剧荒。',
    label: '每日更新',
    img: 'https://readdy.ai/api/search-image?query=A%20fresh%20energetic%20cinematic%20abstract%20design%20with%20bright%20coral%20and%20warm%20orange%20gradients%2C%20fast%20paced%20daily%20updates%20theme%2C%20dynamic%20motion%20feel%2C%20dark%20background%2C%20fresh%20content%20vibe%2C%20no%20people%20no%20text%2C%20vibrant%20editorial%20aesthetic&width=800&height=500&seq=car-5-daily-2026&orientation=landscape',
  },
  {
    title: '移动观影新体验',
    desc: '手机端专享优化的国产视频在线观看免费体验，随时随地畅享高清国产影片。',
    label: '体验升级',
    img: 'https://readdy.ai/api/search-image?query=A%20modern%20mobile%20streaming%20cinematic%20abstract%20design%20with%20warm%20copper%20and%20rose%20gold%20gradients%2C%20smartphone%20and%20play%20button%20motifs%2C%20dark%20background%2C%20on%20the%20go%20entertainment%20theme%2C%20no%20people%20no%20text%2C%20sleek%20contemporary%20aesthetic&width=800&height=500&seq=car-6-mobile-2026&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950">
            焦点专题
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-[560px] mx-auto">
            91免费视频网站精选专题策划，发现不一样的国产视频精彩
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <div
              key={item.title}
              className="rounded-xl overflow-hidden bg-background-50 border border-background-200/60 transition-all duration-200 hover:-translate-y-0.5 cursor-pointer"
            >
              <div className="relative h-[200px] md:h-[220px] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-accent-500/85 text-background-50 text-xs font-medium whitespace-nowrap">
                  {item.label}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900">{item.title}</h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                <div className="mt-3 flex items-center gap-1.5 text-primary-500 text-sm font-medium cursor-pointer">
                  <span className="whitespace-nowrap">查看专题</span>
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}